module.exports = __webpack_public_path__ + "static/media/Test6.2a218813.bmp";